import { useQuery } from '@tanstack/react-query';
import { getCaseDocument } from '../services/fn-api/Cases';
import { CASE_DOCUMENTS_KEY } from 'src/utils/constants/queryKeys';

export const useGetCaseDocuments = (beneId: number, caseId: number) => {
  return useQuery({
    queryKey: [CASE_DOCUMENTS_KEY, beneId, caseId],
    queryFn: () => getCaseDocument(beneId, caseId),
    enabled: !!caseId && !!beneId,
  });
};
